// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"374bf38f","232":"98e0b508","237":"fb4353f4","357":"14e44970","526":"92ffbaba","753":"5637d4af","854":"634c3cf2","872":"95260d63"}[chunkId] + ".chunk.js";
};